import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import Phrase from '../../libs/translationsUtils/phrase'
import { LikedUserType } from '../topic-list-view/LikedUsers'

interface Props {
  votedUsers: Array<LikedUserType>
}

const VotedUsers = ({ votedUsers }: Props) => (
  <div className='box__content widget box__pad idea_voted-users-widget'>
    <div className='idea_voted-users-container'>
      <h3 className='widget-title'><Phrase p='idea.upvoted.by' /> ({votedUsers.length})</h3>
      <div>
        {
          votedUsers.map(user => <UserAvatar
            user={user}
            extraClass='voted-user-avatar avatar--responsive'
            showRank
          />)
        }
      </div>
    </div>
  </div>
)

export default VotedUsers
